import React, { useEffect, useState } from "react";
import { Button, Table, Row, Tag, Popconfirm, notification } from "antd";
import { useLoading } from "../../context/loadingContext";
import GetVatMerchants from "../../functions/merchant/getVatMerchant";
import MerchantAddEdit from "../../components/modal/merchantAddEdit";
import SearchMerchant from "../../components/search/searcMerchant";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import DeleteVatMerchant from "../../functions/merchant/deleteVatMerchant";
import { bg_button } from "constant/css";
import { getMerchantId } from "service/storage";

const DEFAULT_PAGE_SIZE = 20;

const buildQuery = (filters, page, pageSize) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  params.set("page", String(page));
  params.set("size", String(pageSize));
  return params.toString();
};

const MerchantVatMerchant = () => {
  const [editingMerchantId, setEditingMerchantId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [merchants, setMerchants] = useState([]);
  const [paginationData, setPaginationData] = useState({
    total: 0,
    size: DEFAULT_PAGE_SIZE,
  });
  const merchantId = getMerchantId();
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [refreshTick, setRefreshTick] = useState(0);
  const { showLoading, hideLoading } = useLoading();
  const handleShow = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const reload = () => setRefreshTick((tick) => tick + 1);

  const onFilterChange = (field, value) => {
    setPage(1);
    setFilters((prev) => {
      const next = { ...prev };
      if (!value) delete next[field];
      else next[field] = value;
      return next;
    });
  };

  const onSortChange = (field, direction) => {
    setPage(1);
    setFilters((prev) => ({ ...prev, sortField: field, sort: direction }));
  };

  const searchProps = {
    filterValues: filters,
    onFilterChange,
    onSortChange,
  };

  const columns = [
    {
      title: "#",
      render: (t, r, index) => (page - 1) * pageSize + index + 1,
      width: 60,
      fixed: "left",
    },
    {
      title: <SearchMerchant title="Нэр" fieldName="name" {...searchProps} />,
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 250,
    },
    {
      title: (
        <SearchMerchant title="Регистр" fieldName="register" {...searchProps} />
      ),
      dataIndex: "register",
      key: "register",
      width: 150,
    },
    {
      title: (
        <SearchMerchant
          select={[
            { value: "ALL", title: "Сонго" },
            { value: "VAT_ABLE", title: "НӨАТ Төлөгч" },
            { value: "VAT_FREE", title: "НӨАТ Төлөгч биш" },
          ]}
          title="Татварын төрөл"
          fieldName="taxType"
          width={150}
          {...searchProps}
        />
      ),
      dataIndex: "taxType",
      key: "taxType",
      width: 170,
    },
    {
      title: (
        <SearchMerchant
          title="Үйлчилгээ"
          fieldName="serviceName"
          {...searchProps}
        />
      ),
      dataIndex: "serviceName",
      key: "serviceName",
      width: 250,
    },
    {
      title: (
        <SearchMerchant title="Ү/код" fieldName="serviceCode" {...searchProps} />
      ),
      dataIndex: "serviceCode",
      key: "serviceCode",
      width: 140,
    },
    {
      title: (
        <SearchMerchant
          title="Бүтээгдэхүүн код"
          fieldName="taxProductCode"
          {...searchProps}
        />
      ),
      dataIndex: "taxProductCode",
      key: "taxProductCode",
      width: 180,
    },
    {
      title: (
        <SearchMerchant
          title="Хүсэлт"
          select={[
            { value: "ALL", title: "Сонго" },
            { value: "APPROVED", title: "Баталгаажсан" },
            { value: "SENT_REQUEST", title: "Хүсэлт илгээсэн" },
          ]}
          fieldName="approved"
          width={150}
          {...searchProps}
        />
      ),
      dataIndex: "approved",
      key: "approved",
      width: 170,
      render: (e) =>
        e && e == "APPROVED" ? (
          <Tag color="cyan">Баталгаажсан</Tag>
        ) : (
          <Tag color="default">Хүсэлт илгээсэн</Tag>
        ),
    },
    {
      title: (
        <SearchMerchant
          select={[
            { value: "ALL", title: "Сонго" },
            { value: "ACTIVE", title: "Идэвхтэй" },
            { value: "INACTIVE", title: "Идэвхгүй" },
          ]}
          title="Төлөв"
          fieldName="status"
          width={130}
          {...searchProps}
        />
      ),
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (e) =>
        e && e == "ACTIVE" ? (
          <Tag color="cyan">Идэвхтэй</Tag>
        ) : (
          <Tag color="default">Идэвхгүй</Tag>
        ),
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: 100,
      render: (e, r) => {
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            <Button
              type="default"
              onClick={() => editMerchant(r.id)}
              icon={<EditOutlined style={{ color: "#32B7C2" }} />}
            ></Button>
            <Popconfirm
              onConfirm={() => deleteMerchant(r.id)}
              okText="Тийм"
              cancelText="Болих"
              title="Та энэ мерчантыг устгахдаа итгэлтэй байна уу?"
            >
              <Button
                danger
                icon={<DeleteOutlined style={{ color: "red" }} />}
              ></Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  const editMerchant = (id) => {
    setEditingMerchantId(id);
    handleShow();
  };
  const deleteMerchant = async (id) => {
    if (id === 1)
      return notification.error({ message: "Энэ мерчантыг устгах боломжгүй!" });
    showLoading();
    const data = await DeleteVatMerchant(merchantId, id);
    hideLoading();
    if (data) reload();
  };
  useEffect(() => {
    if (!merchantId) return undefined;
    let cancelled = false;
    const timer = setTimeout(async () => {
      showLoading();
      try {
        const body = await GetVatMerchants(
          merchantId,
          buildQuery(filters, page, pageSize)
        );
        if (cancelled || !body || !Array.isArray(body.data)) return;
        setMerchants(body.data);
        setPaginationData(
          body.pagination || { total: body.data.length, size: pageSize }
        );
      } finally {
        if (!cancelled) hideLoading();
      }
    }, 250);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [merchantId, filters, page, pageSize, refreshTick]);
  const addMerchant = () => {
    setEditingMerchantId(null);
    handleShow();
  };
  return (
    <div className="vatMerchantListontainer mt-3">
      <Row>
        <div className="addButtonMerchant">
          <Button
            type="primary"
            className={`${bg_button}`}
            onClick={addMerchant}
          >
            Мерчант бүртгэх
          </Button>
        </div>
      </Row>
      <Table
        rowKey="id"
        scroll={{
          x: "max-content",
        }}
        size="small"
        dataSource={merchants}
        columns={columns}
        pagination={{
          current: page,
          pageSize,
          total: paginationData.total || 0,
          showSizeChanger: true,
          pageSizeOptions: ["20", "50", "100"],
          showTotal: (total) => `Нийт ${total} бичлэг`,
          onChange: (nextPage, nextSize) => {
            if (nextSize !== pageSize) {
              setPageSize(nextSize);
              setPage(1);
              return;
            }
            setPage(nextPage);
          },
        }}
      />

      {showModal && (
        <MerchantAddEdit
          open={showModal}
          close={closeModal}
          vatMerchantId={editingMerchantId}
          refresh={reload}
        />
      )}
    </div>
  );
};

export default MerchantVatMerchant;
